<script setup lang="ts">
import type { LawAndCommentary } from '~/utils/solr/law-and-commentary'
import type { LawCitationInfo } from '~/utils/solr/law-utils'
import { markingNodeType } from '~/utils/markings'

defineProps<{
  node: LawAndCommentary & {
    isSelected?: boolean
    highlightedBodytext: string
  }
  law?: LawCitationInfo
}>()
</script>

<template>
  <div
    :id="node.id.toLowerCase()"
    :class="lawVariants.subsection.base({ selected: node.isSelected, type: node.nodeType })"
    data-citation-source="law"
    data-marking-content-type="law"
    :data-marking-work-id="law?.id"
    :data-marking-document-id="law?.id"
    :data-marking-unit-id="node.id"
    :data-marking-unit-title="node.paragraphTitle || node.title"
    :data-marking-node-type="markingNodeType(node.nodeType)"
    :data-citation-law-id="law?.id"
    :data-citation-title="law?.title"
    :data-citation-short-title="law?.shortTitle"
    :data-citation-paragraph-title="node.paragraphTitle"
    :data-citation-timestamp="node.timestamp ?? undefined"
    :data-citation-law-timestamp="law?.timestamp ?? undefined"
    :data-citation-date-of-publication="law?.dateOfPublication ?? undefined"
    :data-citation-date-in-force="law?.dateInForce ?? undefined"
    :data-citation-last-change-in-force="law?.lastChangeInForce ?? undefined"
    :data-solr-id="node.id"
    :data-solr-timestamp="node.timestamp"
  >
    <slot />
  </div>
</template>
